import React from 'react'

import type { DoneUploadItem, UploadItem } from '../PatientFilesUpload'
import type { RenameState } from './useRenameFile'
import FilenameDisplay from './FilenameDisplay'
import RenameEditor from './RenameEditor'

type Props = {
  item: UploadItem
  activeRename: RenameState | null
  renameInputRef: React.RefObject<HTMLInputElement | null>
  onRenameFilenameChange: (newFilename: string) => void
  onCancelRename: () => void
  onStartRename: (item: DoneUploadItem) => void
  onSaveRename: (item: DoneUploadItem) => void
}

const FilenameCell = ({
  item,
  activeRename,
  renameInputRef,
  onRenameFilenameChange,
  onCancelRename,
  onStartRename,
  onSaveRename,
}: Props) => {
  if (item.status !== 'done') return <>{item.file.filename}</>

  if (activeRename?.fileID === item.file.fileID) {
    return (
      <RenameEditor
        item={item}
        activeRename={activeRename}
        renameInputRef={renameInputRef}
        onRenameFilenameChange={onRenameFilenameChange}
        onCancelRename={onCancelRename}
        onSaveRename={onSaveRename}
      />
    )
  }

  return <FilenameDisplay item={item} onStartRename={onStartRename} />
}

export default FilenameCell
